<template>
    <div class="row">
        <div
            class="subtitle"
            :class="disabled ? 'text-gray-200' :'text-gray-400'"
        >
            {{ label }}
        </div>
        <div
            class="value"
            :class="disabled ? 'text-gray-200' :'text-gray-700'"
        >
            {{ value }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
};
</script>
<style scoped>
.row {
    @apply py-1.5 px-2.5 flex items-center justify-between min-h-[2.5rem];
}
.subtitle {
    @apply text-sm flex-shrink-0;
}
.value {
    @apply text-base xs:text-lg text-right;
}
</style>
